import React from 'react';
import PropTypes from 'prop-types';

const TextPhone = ({ size, className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 72 72"
  >
    <rect width="72" height="72" fill="#E6F3FD" rx="36"></rect>
    <path
      fill="#008AEA"
      d="M38.776 21.367c0-.646-.518-1.167-1.16-1.167h-6.18c-.642 0-1.16.521-1.16 1.167 0 .645.518 1.166 1.16 1.166h6.18c.64 0 1.16-.521 1.16-1.166"
    ></path>
    <path
      fill="#008AEA"
      d="M55.444 26.033h-8.706v-5.19c0-2.37-1.914-4.298-4.27-4.298h-15.88c-2.355 0-4.27 1.927-4.27 4.299v32.31c0 2.37 1.914 4.3 4.27 4.3h15.88c2.354 0 4.27-1.928 4.27-4.3V42.843h8.708c2.888 0 5.24-2.36 5.24-5.268l-.003-6.267c0-2.908-2.35-5.274-5.24-5.274m-10.56 27.124a2.43 2.43 0 0 1-2.417 2.431h-15.88a2.43 2.43 0 0 1-2.415-2.431V20.844a2.43 2.43 0 0 1 2.416-2.432h15.88a2.43 2.43 0 0 1 2.415 2.432v5.19h-2.611c-2.883 0-5.234 2.366-5.234 5.273v14.461a.933.933 0 0 0 .927.934c.2 0 .399-.066.561-.192l4.78-3.667h1.576zm4.983-14.837h-5.331a.927.927 0 0 1-.928-.934.93.93 0 0 1 .928-.933h5.331c.511 0 .928.42.928.933a.93.93 0 0 1-.928.934m3.246-5.367h-8.577a.927.927 0 0 1-.928-.933.93.93 0 0 1 .928-.934h8.577c.51 0 .927.42.927.934a.93.93 0 0 1-.927.933"
    ></path>
  </svg>
);

TextPhone.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

TextPhone.defaultProps = {
  size: 72,
  className: '',
};

export default TextPhone;
